module.exports = __webpack_public_path__ + "c8db91143a61a82dd5ea14c4fb3660c3.png";